<template>
  <Tag :severity="status === 'บันทึก' ? 'warning' : 'success'">{{
    status
  }}</Tag>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ReleaseStatusBadge",
  props: {
    status: {
      type: String,
      required: true,
    },
  },
});
</script>

<style></style>
